import dayjs from "dayjs";
import { globalProps } from "neetocommons/initializers";

export const getBrowserTimeZone = () => dayjs.tz.guess();

export const getUserTimeZone = () => globalProps.user?.timeZone;

export const checkIfTwoTimeZonesAreSame = (timeZone1, timeZone2) =>
  // eslint-disable-next-line @bigbinary/neeto/use-standard-date-time-formats
  dayjs().tz(timeZone1).format("Z") === dayjs().tz(timeZone2).format("Z");
